import palette from 'src/styles/palette';
import styled from 'styled-components';

type CumaButtonStyle = 'primary' | 'primary-outline' | 'gray-outline' | 'light-gray-outline';
type CumaButtonSize = 'lg' | 'md' | 'sm';

const setBackground = (style: CumaButtonStyle): string => {
    switch (style) {
        case 'primary':
            return `${palette.primary}`;
        default:
            return `#fff`;
    }
};

const setBorder = (style: CumaButtonStyle): string => {
    switch (style) {
        case 'primary':
            return `none`;
        case 'primary-outline':
            return `1px solid ${palette.primary}`;
        case 'gray-outline':
            return `1px solid #aaa`;
        case 'light-gray-outline':
            return `1px solid #ddd`;
        default:
            return `none`;
    }
};

const setColor = (style: CumaButtonStyle): string => {
    switch (style) {
        case 'primary':
            return `#fff`;
        case 'primary-outline':
            return `${palette.primary}`;
        default:
            return `#222`;
    }
};

const setHeight = (size: CumaButtonSize): string => {
    switch (size) {
        case 'lg':
            return `56px`;
        case 'md':
            return `46px`;
        case 'sm':
            return `32px`;
        default:
            return `56px`;
    }
};

export const CumaButtonType = styled.button<{ $cumaButtonStyle?: CumaButtonStyle; size?: CumaButtonSize }>`
    width: 100%;
    height: ${({ size }) => setHeight(size)};
    border: none;
    cursor: pointer;
    font-size: 16px;
    padding: 0;
    background: ${({ $cumaButtonStyle: cumaButtonStyle }) => setBackground(cumaButtonStyle)};
    border: ${({ $cumaButtonStyle: cumaButtonStyle }) => setBorder(cumaButtonStyle)};
    color: ${({ $cumaButtonStyle: cumaButtonStyle }) => setColor(cumaButtonStyle)};

    &:disabled {
        background: #f6f6f6;
        font-weight: 500;
        font-size: 16px;
        line-height: 23px;
        color: #aaaaaa;
        border: none;
    }
`;
